module.exports = __webpack_public_path__ + "static/img/07-06.98a3e13f.png";